<div class="main-div">
  <span class="error">Please verify that a prior authorization is required prior to using the Clinical Documentation Look-Up Tool.</span>
  <span class="error">* required</span>
  <form [formGroup]="searchForm">
    <div class="selected_tab-div">
      <div style="display: flex; flex-direction: row">
        <div style="margin-right: 52px">
          <span class="protext">Plan Type</span>
          <select aria-label="plan type" class="select_input" (change)="handlePolicyNumber()" formControlName="plantype" required>
            <option value=''>Select Plan Type</option>
            <option *ngFor="let val of plantypeList" [value]="val">{{ val }}</option>
          </select>
          <span class="error" *ngIf="(searchFormControl.plantype.touched || formSubmitted) && searchFormControl.plantype.errors?.required">
            Plan Type is required!
          </span>
        </div>
        <div style="margin-right: 52px">
          <span class="protext">State</span>
          <select aria-label="state" class="select_input" [(ngModel)]="selectedState" (change)="handleStateChange()" formControlName="state" required>
            <option value=''>Select State</option>
            <option *ngFor="let item of statesList" [value]="item">{{ item }}</option>
          </select>
          <span class="error" *ngIf="(searchFormControl.state.touched || formSubmitted) && searchFormControl.state.errors?.required">
            State is required!
          </span>
        </div>
        <diV style="display: flex; flex-direction: column;">
          <span class="text">Service Date</span>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="picker" aria-describedby="MM/DD/YYYY" formControlName="servicedate" (dateChange)="handlePolicyNumber()" aria-label="service date" readonly>
            <mat-datepicker-toggle role="time" aria-label="date picker" matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker role="time" #picker color="primary"></mat-datepicker>
          </mat-form-field>
        </diV>
      </div>
      <div style="display: flex; flex-direction: row; margin: 10px 0px">
        <div style="margin-right: 52px;" aria-label="Procedure info">
          <span class="protext" style="margin-bottom: 2px;">Procedure Code Search</span>
          <div class="pxcode-search-div">
            <div>
              <span class="text">Procedure Code</span>
              <input aria-label="procedure code" maxlength="10" type="text" class="select_input" style="width: 230px;" formControlName="pcode"
                (keypress)="allowAlphaNumeric($event)" (change)="procedureCodeChange()" />
              <mat-hint class="key-search-hint">Maximum 10 characters,only alpha numeric</mat-hint>
              <br>
              <span class="error" *ngIf="(searchFormControl.pcode.touched || formSubmitted) && searchFormControl.pcode.errors?.required">
                Procedure Code is required!
              </span>
            </div>
            
            <p class="ortext">OR</p>

            <div style="display: flex; flex-direction: column;">
              <span class="text">Keyword Search</span>
              <mat-form-field appearance="outline" style="height: 35px;">
                <input matInput aria-label="keyword Search" [matAutocomplete]="auto" formControlName="keySearch" style="line-height: 0px;" (keyup)="handleKeywordSearch()">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onKeyWordSearchSelect($event)">
                  <mat-option *ngFor="let option of filteredPXDesc" [value]="option"  [matTooltip]="option">
                    {{ option }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-hint class="key-search-hint">Minimum 5 characters</mat-hint>
            </div>
          </div>
        </div>
        <diV class="proDesc-div">
          <span class="text">Procedure Description</span>
          <mat-form-field appearance="outline" style="width: 250px; font-family: Lato; font-size: 14px; height: 36px;">
            <input matInput aria-label="procedure code description" formControlName="pxcodedesc" [matTooltip]="pxCodeDesc" readonly />
          </mat-form-field>
          <p *ngIf="pxDescException" class="error">Procedure Description is Invalid/Not Found</p>
        </diV>
        <div style="margin-top: 60px;">
          <div style="display: flex; flex-direction: row; height: 16px;">
            <span class="text">Policy</span>
            <button class="info-icon-btn" aria-label="policy info icon">
              <mat-icon
                class="info-icon"
                matTooltip="Policies can be displayed after selecting the State and Plantype. Further filtered when a procedure code is entered."
                matTooltipPosition="above"
                aria-tooltip="Icon that displays a tooltip when focused or hovered over"
                aria-label="info icon"
              >
                info
              </mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline" style="width: 230px">
            <mat-select aria-label="policy" formControlName="policy" (selectionChange)="policySelection()">
              <mat-option value=''>Select Policy</mat-option>
              <mat-option
                *ngFor="let label of policyDetails"
                [value]="label.policyNumber"
                [matTooltip]="label.policyDescription"
                matTooltipPosition="right"
              >
                {{ label.policyNumber }}
              </mat-option>
            </mat-select> 
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div style="display: flex; flex-direction: row; margin: 20px 0px 10px 10px">
      <button class="search_button" data-analytics="searchButtonCdlt" (click)="handleSearch()" [disabled]="hideSearch">Search</button>
      <button class="reset_button" data-analytics="resetButtonCdlt" (click)="resetProCode()">Reset</button>
    </div>
  </form>
</div>
  
<div class="button-div">
  <div style="padding-left: 22px; width: 80%;">
    <p class="disclaimer-text" style="margin-top: 2px;">
      <strong>Disclaimer:</strong> The content is not meant to be a substitution for the Medical Policies or Clinical
      UM Guidelines that are currently in effect. Saving this content outside of this tool may result in outdated
      information at time of use. Medical Policies and UM Guidelines are updated regularly, so use this tool to
      ensure you are gathering the most current information. 
    </p>
  </div>
  
  <div *ngIf="searchFormControl.plantype.value && searchFormControl.state.value">
    <button
      mat-icon-button
      [matMenuTriggerFor]="downloadMenu"
      aria-label="icon-button with a menu"
      class="reset_button" data-analytics= "downloadResultsButtonCdlt" style="width: 140px">
      Download Results  
    </button>
    <mat-menu #downloadMenu="matMenu"> 
      <button mat-menu-item aria-label="Current recommendation" (click)="downloadCurrRecomendation()" *ngIf="searchFormControl.pcode.value && !hideSearch">
        <span class="text">Download Current Recommendation</span>
      </button>
      <button mat-menu-item aria-label="State & plantype recommendation" (click)="downloadStatePlanRecom()">
        <span class="text">Download State & Plantype Recommendation</span>
      </button>
    </mat-menu>
  </div>
</div>

<div *ngIf="noDataAvailable" class="main-div noData-div">
  <p class="noData-message">No data available.</p>
</div>

<div *ngIf="isProgressing" class="progress-spinner-div">
  <mat-progress-spinner class="progress-spinner" aria-label="progress spinner" mode="determinate" [value]="progressValue"></mat-progress-spinner>
  <span class="percent-count">{{ progressValue }}%</span>
</div>

<app-loader *ngIf="isLoading"></app-loader>
